var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnTw = function SvgIcnTw(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    alt: "twitter",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_tw",
    transform: "translate(-2806 -6105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Group_30",
    "data-name": "Group 30",
    d: "M15.754,8.41a5.1,5.1,0,0,0,1.218-1.216,4.759,4.759,0,0,1-1.406.36,2.329,2.329,0,0,0,1.078-1.306,5.319,5.319,0,0,1-1.546.586,2.508,2.508,0,0,0-1.8-.743,2.414,2.414,0,0,0-2.46,2.365A2.14,2.14,0,0,0,10.9,9,7.237,7.237,0,0,1,5.82,6.518a2.233,2.233,0,0,0-.328,1.194,2.306,2.306,0,0,0,1.1,1.96,2.673,2.673,0,0,1-1.125-.293V9.4a2.393,2.393,0,0,0,1.968,2.32,2.849,2.849,0,0,1-.633.09,3.3,3.3,0,0,1-.469-.045,2.438,2.438,0,0,0,2.3,1.644,5.073,5.073,0,0,1-3.046,1.014A4.735,4.735,0,0,1,5,14.379a7.055,7.055,0,0,0,3.772,1.059,6.782,6.782,0,0,0,6.982-6.712Z",
    transform: "translate(2803 6101.91)",
    fill: "rgba(102,102,102,0.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 16,
    height: 16,
    transform: "translate(2806 6105)",
    fill: "none"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnTw, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_tw.461a5468.svg";
export { ForwardRef as ReactComponent };